var _templateObject;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled from 'styled-components';
import MuiTab from '@mui/material/Tab';
export var StyledTab = styled(MuiTab)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  line-height: 1.4;\n  &&:not(:disabled) {\n    opacity: 1;\n  }\n"])));